import type { IconGlyph } from '../icon';

/**
 * Tractie `star-thick` glyph (medium, 24×24), shown on a selected item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/star-thick.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconStarThick: IconGlyph = {
  name: 'star-thick',
  path: 'M20.58 8.44 15.43 8l-1.98-5.02c-.15-.38-.45-.69-.82-.85h-.02a1.54 1.54 0 0 0-2.03.87L8.59 8.01l-5.15.44c-.43.03-.81.23-1.08.57s0 .02 0 .02c-.48.62-.47 1.59.19 2.17l3.96 3.58-1.21 5.29c-.1.42-.02.85.18 1.18.43.72 1.39 1.01 2.16.52l4.39-2.81 4.4 2.81c.33.21.77.31 1.22.19.84-.23 1.29-1.07 1.12-1.87s-1.22-5.32-1.22-5.32l3.95-3.57c.98-.87.54-2.64-.9-2.75Zm-5.27 5.62 1.24 5.42L12 16.57l-4.55 2.91 1.24-5.4-4.12-3.73 5.4-.46L12 4.78l2.02 5.11 5.4.46-4.11 3.72Z',
};
